// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'
import { castToString } from 'helpers/reduxFormFunctions'

// segment_end_radio and segment_end_modulation data are not combined in the JSON.
// due to UI needs, this data is merged in a property called 'modConfigs' which
// the tooltip on project summary uses and also when loading path data for path details.
// modulations here maps to the JSON's segmentEnd[i].radio.modulations
// - this is the default values that a radio's modulations have
// whereas radioModulationConfigurations maps to segmentEnd[i].radioModulationConfigurations
// - this is the configured values of modulations on the segment_end
const createModConfigs = segmentEnd => {
  if (segmentEnd.radio === null) {
    return []
  }

  const {
    radio: {
      modulations,
      modulationType,
    },
    radioModulationConfigurations,
  } = segmentEnd

  // a radio must have a modulation type assigned. this is helpful in identifying transformation issues from
  // Legacy data in to Lego data.
  // TODO - remove once Legacy data transformation is complete
  if (!modulationType) {
    throw new Error('Warning! A segment end was assigned a radio which has no modulation type assigned.')
  }

  // if there are no modulations configured at the segment end level
  // (the radioModulationConfigurations)
  // but a radio is assigned, there was a data transformation issue from
  // legacy data.
  // gracefully warn the user.
  // TODO - remove once Legacy data transformation is complete
  if (!radioModulationConfigurations.length) {
    throw new Error('Warning! A segment end was assigned a radio but no modulations were configured.')
  }

  return modulations.reduce((a, mod) => {
    // this is used for display to the user
    const modulationSchemeLabel = makeModulationSchemeLabel(mod.modulationScheme)

    // assume a modulation isn't enabled,
    // it will have no assigned power and
    // will not be the engineering reference.
    const cfg = {
      enabled: false,
      engineeringReferenceFlag: false,
      power: '',
      segmentEndRadioModulationId: null,
    }

    const matchingRadioModulationConfiguration = (
      radioModulationConfigurations.find(d => d.radioModulationId === mod.radioModulationId)
    )

    if (matchingRadioModulationConfiguration) {
      cfg.enabled = true
      cfg.engineeringReferenceFlag = matchingRadioModulationConfiguration.engineeringReferenceFlag

      cfg.power = castToString(matchingRadioModulationConfiguration.power)
      cfg.segmentEndRadioModulationId = matchingRadioModulationConfiguration.segmentEndRadioModulationId
    }

    a.push({
      ...mod,
      ...cfg,
      modulationSchemeLabel,
    })
    return a
  }, [])
}

export default createModConfigs
